import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 ${$props.width} ${$props.height}`,
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M2 5.5C3.19347 5.5 4.33807 5.97411 5.18198 6.81802C6.02589 7.66193 6.5 8.80653 6.5 10M2 2C4.12173 2 6.15656 2.84285 7.65685 4.34315C9.15715 5.84344 10 7.87827 10 10M3 9.5C3 9.77614 2.77614 10 2.5 10C2.22386 10 2 9.77614 2 9.5C2 9.22386 2.22386 9 2.5 9C2.77614 9 3 9.22386 3 9.5Z",
    stroke: $props.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}